/* SAMPLE COLLECTORS */
export const GET_LABS_RATING = "GET_LABS_RATING";
export const GET_LABS_RATING_SUCCESS =
  "GET_LABS_RATING_SUCCESS";
export const GET_LABS_RATING_FAIL = "GET_LABS_RATING_FAIL";
